import React, { useEffect, useState } from 'react'

import { useLocation, useNavigate, useParams } from 'react-router-dom'

import { StudentBonus, StudentCourses } from '..'
import {
  DetailPerson,
  InlineMenuNoButton,
  SectionSubtitle,
  ListWithSearch,
  FilteringList,
  DeleteUserButton,
  Button,
} from '../../..'
import { useCupons, useModal, useStudents, useUser } from '../../../../context'
import {
  AdminStudentMenu,
  AnyProfile,
  Profesor,
  Student,
} from '../../../../types'
import { convertToRoles } from '../../../../utilFunctions'
import { Spacer } from '../../../global'
import DeleteUserModal from '../../../modal/DeleteUserModal'
import ProfileView from '../../../profile/ProfileView'
import { AdminsContainer, ProfileDataSection } from '../styles'

const Students = () => {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const { part } = useParams<{ part: string }>()

  const { saveStudent, activeStudent, setActiveStudent, studentsList } =
    useStudents()

  const { cupons, setStudentCupons, studentCupons } = useCupons()
  const { setModalStatus } = useModal()

  const { onEditionMode, setOnEditionMode } = useUser()

  const [searchValue, setSearchValue] = useState<string>('')
  const [filteredStudents, setFilteredStudents] = useState<Student[] | null>(
    null,
  )
  const [showConfirmationDeleteModal, setShowConfirmationDeleteModal] =
    useState<boolean>(false)

  const selectStudent = (student: Profesor | Student) => {
    if (!onEditionMode && 'professors' in student) {
      setActiveStudent(student as Student)

      navigate(`/alumnos/${AdminStudentMenu.bonos.label}`)
    } else {
      setActiveStudent(student as Student)
    }
  }

  const updateProfile = () => {
    if (activeStudent) {
      saveStudent(activeStudent, activeStudent.uid)
      setOnEditionMode(!onEditionMode)
    }
  }

  useEffect(() => {
    if (activeStudent) {
      const filterCupons = cupons.filter(
        (cupon) => cupon.idStudent === activeStudent.uid,
      )
      setStudentCupons(filterCupons)
    }
  }, [activeStudent, cupons])

  useEffect(() => {
    setFilteredStudents(FilteringList(searchValue, studentsList))
  }, [searchValue, studentsList])

  useEffect(() => {
    if (activeStudent === null && !onEditionMode && studentsList) {
      setActiveStudent(studentsList[0])
      navigate(`/alumnos/${AdminStudentMenu.bonos.label}`)
    }
  }, [])

  const resetStudents = () => {
    setActiveStudent(null)
    setOnEditionMode(false)
    studentsList && setActiveStudent(studentsList[0])
    navigate(`/alumnos/${AdminStudentMenu.bonos.label}`)
    setShowConfirmationDeleteModal(false)
  }

  return (
    <AdminsContainer>
      {showConfirmationDeleteModal && (
        <DeleteUserModal resetUsers={resetStudents} />
      )}
      <ListWithSearch
        type="alumno"
        searchValue={searchValue}
        filteredStudents={filteredStudents}
        setSearchValue={setSearchValue}
        selectStudent={selectStudent}
      />
      <div className="data">
        {activeStudent && (
          <>
            <InlineMenuNoButton
              parent="alumnos"
              menu={AdminStudentMenu}
              editing={onEditionMode}
            />
            {part !== AdminStudentMenu.profile.label && (
              <ProfileDataSection>
                <DetailPerson person={activeStudent} />

                {!onEditionMode && activeStudent && (
                  <DeleteUserButton
                    userToDeleteUID={activeStudent.uid}
                    userToDeleteRole={convertToRoles(
                      activeStudent.role as string,
                    )}
                    setActiveUserNull={() =>
                      setShowConfirmationDeleteModal(true)
                    }
                  />
                )}
              </ProfileDataSection>
            )}

            <div>
              <div className="section-title">
                <SectionSubtitle fontWeight={500} fontSize={16} lineHeight={24}>
                  <>
                    {part === AdminStudentMenu.profile.label
                      ? 'Datos personales'
                      : part === AdminStudentMenu.courses.label
                        ? AdminStudentMenu.courses.description
                        : AdminStudentMenu.bonos.description}
                  </>
                </SectionSubtitle>

                {!onEditionMode && part === AdminStudentMenu.profile.label && (
                  <div className="buttons-row">
                    <Button
                      disabled={onEditionMode}
                      onClick={updateProfile}
                      label="Editar"
                    />

                    {activeStudent && (
                      <DeleteUserButton
                        userToDeleteUID={activeStudent.uid}
                        userToDeleteRole={convertToRoles(
                          activeStudent.role as string,
                        )}
                        setActiveUserNull={() =>
                          setShowConfirmationDeleteModal(true)
                        }
                      />
                    )}
                  </div>
                )}
                {part === AdminStudentMenu.bonos.label && (
                  <Button
                    label="Agregar Bono"
                    disabled={onEditionMode}
                    onClick={() => setModalStatus(true)}
                  />
                )}
              </div>
              <Spacer height={16} />
            </div>

            {part === AdminStudentMenu.bonos.label && studentCupons && (
              <StudentBonus
                studentCupons={studentCupons}
                activeStudent={activeStudent}
              />
            )}
            {part === AdminStudentMenu.courses.label &&
              activeStudent.courses && <StudentCourses />}

            {part === AdminStudentMenu.profile.label && (
              <>
                <Spacer height={32} />

                <ProfileView
                  initialProfile={activeStudent as AnyProfile}
                  isNewUser={pathname === '/nuevo-usuario'}
                />
              </>
            )}
          </>
        )}
      </div>
    </AdminsContainer>
  )
}

export default Students
